import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
// import { FiChevronDown } from 'react-icons/fi';

const TopNav = ({ toggleSidebar, isOpen }) => {
  const navigation = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);

  const toggleDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowDropdown(!showDropdown);
  };

  const handleLogout = () => {
    const userToken = localStorage.getItem('token');
    const adminToken = localStorage.getItem('admin_token');

    localStorage.clear();

    if (userToken) {
      navigation('/auth/signin');
    } else if (adminToken) {
      navigation('/auth/admin_login');
    }
    setShowDropdown(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown')) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      <header class="topbar w-full lg:pl-[280px]">
        <div class="container-fluid">
          <div class="navbar-header">
            <div class="d-flex align-items-center">
              <div class="topbar-item">
                <button
                  type="button"
                  class="button-toggle-menu me-2 lg:hidden block"
                  onClick={() => toggleSidebar(!isOpen)}
                >
                  <iconify-icon
                    icon="solar:hamburger-menu-broken"
                    class="fs-24 align-middle"
                  ></iconify-icon>
                </button>
              </div>

              <div class="topbar-item">
                <h4 class="fw-bold topbar-button pe-none text-uppercase mb-0">
                  Welcome!
                </h4>
              </div>
            </div>

            <div class="d-flex align-items-center gap-1">

              <div className="dropdown topbar-item">
                <div className="position-relative">
                  <a
                    type="button"
                    className="topbar-button"
                    onClick={toggleDropdown}
                  >
                    <span className="d-flex align-items-center gap-2">
                      <img
                        className="rounded-circle cursor-pointer"
                        width="32"
                        src="/assets/img/avatar-profile-photo.png"
                        alt="avatar-3"
                      />
                    </span>
                  </a>

                  {showDropdown && (
                    <div
                      className="dropdown-menu dropdown-menu-end"
                      style={{
                        position: 'absolute',
                        top: '100%',
                        right: 0,
                        display: 'block',
                        minWidth: '200px',
                        padding: '0.5rem 0',
                        backgroundColor: '#fff',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                        borderRadius: '4px',
                        zIndex: 1000,
                      }}
                    >
                      <h6 className="dropdown-header">Welcome User!</h6>
                      <NavLink
                        to={'/dashboard/profile'}
                        className="dropdown-item"
                      >
                        <i className="bx bx-user-circle text-muted fs-18 align-middle me-1"></i>
                        <span className="align-middle">Profile</span>
                      </NavLink>
                      <NavLink to={'/dashboard/chat'} className="dropdown-item">
                        <i className="bx bx-message-dots text-muted fs-18 align-middle me-1"></i>
                        <span className="align-middle">Messages</span>
                      </NavLink>
                      <div className="dropdown-divider my-1"></div>
                      <a
                        className="dropdown-item text-danger"
                        onClick={handleLogout}
                      >
                        <i className="bx bx-log-out fs-18 align-middle me-1"></i>
                        <span className="align-middle">Logout</span>
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default TopNav;
